import React from "react";
import './result.style.css';
import HeaderSurvey from '../../components/headersurvey/headersurvey.component';

const ResultPage = (props) => {
  const { doseTime, doseVaccine } = props;
  return (
    <main className="main_result">
      <section className="pp-section pp-section--result section_bg">
        <div className="section-inner results-inner--wrapper">
          <div className="pp-quiz-resultheader">
            <div className="pp-resultheader--header">
              <a href="/">
                <img
                  alt="Dawa Asaan Logo"
                  src={require("../../assets/images/Logo.png")}
                />
                <span className="sr-only">Homepage</span>
              </a>
              {/* <ReactToPrint
                trigger={() => <a href="#" className="button-pill">
                  <p className="hide-mobile">Print Prescription</p>
                </a>}
                content={() => ResultPage}
              /> */}
              <a
                href="/"
                className="pp-cta-button fill large">
                Get Started
            </a>
            </div>
            <h1 className="results-h mb-4">
              <span className="js-result--subj-title">Your Dawa Asaan Medication Pack</span>
            </h1>
          </div>
          <div className="section-inner pp-inner--split">
            <div className="pp-split-mod pp-txt-mod each-day">
              <h2 className="result-hero-h">Each Day</h2>
            </div>
            <div className="pp-txt-mod--secondary result-txt-mod">
              <h3 className="result-subh">
                <span className="js-result-freq">{doseTime.length}</span> Daily Dose Pouches
                </h3>
              <p className="section-p">
                Your Dawa Asaan My Med Pack, comes pre-sorted and pre-packed as to your doctor's prescription. Your medicine is packaged into dose pouches, with the date, time and medicine within clearly labelled onto each pouch. We package your medication exactly as to your prescription, so you’ll always have the right medicines at the right time.
                {/* <span className="js-result--subj-own">your</span>
                <span className="js-result-count">1–3</span> meds come pre-sorted
                    into packets <span className="js-result-freq">{doseTime.length}</span> time per day.
                    We package medications exactly as they’re prescribed, so
                <span className="js-result--subj">you</span>’ll always have the
                    right meds at the right time. We can also send bottles of as-needed
                    meds. */}
              </p>
              <div className="inline-items-mod inline-central-mod no-break">
                {
                  doseTime.includes("morning") && (
                    <div className="inline-item js-result-morning">
                      <div className="inline-item-art packet">
                        <picture>
                          <source
                            srcSet={require("../../assets/images/ezgif.png")}
                            type="image/webp"
                          />
                          <img
                            alt="Dawa Asaan packet of pills"
                            className="inline-item-img"
                            src={require("../../assets/images/ezgif.png")}
                          />
                        </picture>
                      </div>
                      <span className="section-subh">Morning</span>
                    </div>
                  )
                }
                {
                  doseTime.includes("after_noon") && (
                    <div className="inline-item js-result-morning">
                      <div className="inline-item-art packet">
                        <picture>
                          <source
                            srcSet={require("../../assets/images/ezgif.png")}
                            type="image/webp"
                          />
                          <img
                            alt="Dawa Asaan packet of pills"
                            className="inline-item-img"
                            src={require("../../assets/images/ezgif.png")}
                          />
                        </picture>
                      </div>
                      <span className="section-subh">Afternoon</span>
                    </div>
                  )
                }

                {
                  doseTime.includes("evening") && (
                    <div className="inline-item js-result-morning">
                      <div className="inline-item-art packet">
                        <picture>
                          <source
                            srcSet={require("../../assets/images/ezgif.png")}
                            type="image/webp"
                          />
                          <img
                            alt="Dawa Asaan packet of pills"
                            className="inline-item-img"
                            src={require("../../assets/images/ezgif.png")}
                          />
                        </picture>
                      </div>
                      <span className="section-subh">Evening</span>
                    </div>
                  )
                }
              </div>
            </div>
          </div>
          {
            doseVaccine.length ? (
              <div className="section-inner pp-inner--split js-result-other">
                <div className="pp-split-mod pp-txt-mod result-txt-mod pb-0">
                  <h2 className="result-subh">Other pharmacy items and Vitamins, delivered</h2>
                  <p className="section-p">
                    Your delivery would include a Dawa Asaan Medication Pack and any other pharmacy items. Your digital prescription may be accessed through your dashboard within the Dawa Asaan application and is pasted on to your Medication Pack. This prescription details exactly what is inside your customised Medication Pack. Your Medication Pack also displays a QR code, which when scanned displays the details(i.e DOE, DOM, Batch No. e.t.c) of all medicines within each pouch.
                    {/* <span className="js-result--subj-own">your</span> shipment includes a
                Dawa Assan and any other pharmacy items. Check the med list on
                <span className="js-result--subj-own">your</span> dispenser to see exactly
                what’s inside the packets. We also automatically reach out to doctors for
                refills, so <span className="js-result--subj">you</span>’ll never run out
                of meds. */}
                  </p>
                </div>
                <div className="pp-txt-mod--secondary">
                  <div className="inline-items-mod inline-central-mod no-break">
                    <div className="inline-item">
                      <div className="inline-item-art">
                        <picture>
                          <source
                            srcSet={require("../../assets/images/ezgif1.png")}
                            type="image/webp"
                          />
                          <img
                            alt="Dawaassan packet of pills"
                            className="inline-item-img system-image"
                            src={require("../../assets/images/ezgif1.png")}
                          />
                        </picture>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ) :
              (
                <></>
              )
          }
          <div className="section-inner">
            <div className="inline-items-mod inline-items--break">
              <div className="inline-item">
                <div className="inline-item-art result-stat">
                  <p className="mb-0">
                    <span className="js-result-timesaved">*</span> hours
                  </p>
                </div>
                <p className="section-p mt-0">
                  <strong>Time saved per month</strong>
                </p>
                <p className="section-p width_footer">
                  Customers with similar pharmacy and medication routines saved time each
                  month when they switched to Dawa Assan.
                  </p>
              </div>
              <div className="inline-item">
                <div className="inline-item-art result-stat">
                  <p className="mb-0">PKR 0</p>
                </div>
                <p className="section-p mt-0">
                  <strong>Service fees</strong>
                </p>
                <p className="section-p">We’ll never charge for service or shipping.</p>
              </div>
            </div>
          </div>

        </div>
      </section>
      <section className="pp-section--cta">
        <div className="pp-cta-txt-mod">
          <h1 className="section-h">Switch to a simpler pharmacy today</h1>
          <a
            href="/"
            className="pp-cta-button fill large">
            Get Started
            </a>
        </div>
      </section>
    </main>

  )
}
export default ResultPage;